(function () {
  const productDescription = document.querySelector('.product__description');
  const descriptionToggleBtn = document.querySelector('#toggleDescription');

  if (productDescription && descriptionToggleBtn) {
    descriptionToggleBtn.addEventListener('click', () => {
      if (productDescription.dataset.toggle === 'closed') {
        productDescription.style.height = `${productDescription.scrollHeight}px`;
        productDescription.dataset.toggle = 'opened';
      } else {
        productDescription.style.height = '';
        productDescription.dataset.toggle = 'closed';
      }
    });
  }
})();
